export const dataApiUrl = () => {
  let dataApi = new URL(process.env.REACT_APP_DATA_API_URL);
  return dataApi.origin;
};
